<ng-container *ngIf="!matchBannerService.activeBetting">
  <a *ngIf="link" class="install-banner" [href]="link" target="_blank">
    <img src="assets/images/get-app-banner.svg" alt="App Download">
  </a>

  <button *ngIf="!link" class="install-banner" (click)="openGetAppDialog()">
    <img src="assets/images/get-app-banner.svg" alt="App Download">
  </button>
</ng-container>
<a *ngIf="matchBannerService.activeBetting"
   class="install-banner" [href]="matchBannerService.webUrl" target="_blank">
  <img [src]="matchBannerService.bannerImgUrl" alt="App Download">
</a>
